// CPF helpers — port of the mobile app's CpfInputFormatter / CPFValidator
// (LeopardaElectricApp app/lib/SignIn/validators/cpf_validator.dart), so the
// web revalidation step accepts exactly the same inputs as the app's.

// The backend compares the CPF as an exact string against `user.dni`, which
// stores digits only — everything sent to /verify must go through this.
export const cpfDigits = (value: string): string =>
  value.replace(/\D/g, "").slice(0, 11);

export const formatCpf = (value: string): string => {
  const d = cpfDigits(value);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
};

const checkDigit = (digits: number[]): number => {
  let sum = 0;
  for (let i = 0; i < digits.length; i += 1) {
    sum += digits[i] * (digits.length + 1 - i);
  }
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

// Full check-digit validation. A typo'd CPF must never reach the server:
// ms-login treats a mismatched CPF as a recycled phone and UNLINKS the number
// from the account, so the client blocks everything that cannot possibly be
// a real CPF before submitting.
export const isValidCpf = (value: string): boolean => {
  const d = cpfDigits(value);
  if (d.length !== 11) return false;
  if (d.split("").every((digit) => digit === d[0])) return false;
  const digits = d.split("").map(Number);
  return (
    digits[9] === checkDigit(digits.slice(0, 9)) &&
    digits[10] === checkDigit(digits.slice(0, 10))
  );
};
